// As defined in: https://www.figma.com/design/VHx6KIBqmxn3gbj5RAsX4Z/%E2%9D%96-Untitled-UI-v7.0?node-id=3287-428579&vars=1&var-id=6298-45389&m=dev

const namedSpacing = {
  // https://v1.tailwindcss.com/docs/customizing-spacing#default-spacing-scale
  // This keeps the ability to use classnames like 'h-px', 'w-px', etc.
  // Example https://github.com/AdharkInc/vizit-v2-ui/blob/f7dfa7eb14d35c23d9e59034f3f27cb9613c58ad/packages/atoms/src/components/separator/separator.tsx#L11
  px: '1px',
};

const scaledSpacing = Array.from({ length: 128 }).reduce((spacing: Record<string, string>, _, index) => {
  const rem = 0.125 * index; // 2px = 0.125rem

  spacing[index] = `${rem}rem`;

  return spacing;
}, {});

const spacing = {
  ...namedSpacing,
  ...scaledSpacing,
};

export { spacing };
